import AssetComponent from "components/core/asset/asset-component.js";
import MondayMarkupLanguageComponent from "client/components/system/monday-markup-language/monday-markup-language-component";
import { StyledBadgesSectionComponent } from "./badges-section-component.scss.js";

export default function BadgesSectionComponent(props) {
  const { badgesSections } = props;

  return (
    <StyledBadgesSectionComponent>
      <div className="badges-sections-container">
        {badgesSections?.map((badgesSection, index) => {
          return (
            <div className="badges-section" key={index}>
              <div className="section-header">
                <div className="icon">
                  <AssetComponent image={{ src: badgesSection?.icon }} />
                </div>
                <div className="section-info">
                  <MondayMarkupLanguageComponent className="title" text={badgesSection?.title} />
                  <div className="description">{badgesSection?.description}</div>
                </div>
              </div>
              <div className="badges-container">
                {badgesSection?.badges?.map((badge, index) => {
                  return (
                    <div className="badge" key={index}>
                      <AssetComponent image={{ src: badge?.badgeImage }} />
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </StyledBadgesSectionComponent>
  );
}
